<template>
  <div class="bg-whatsappinput w-full relative">
    <!-- <input
      class="mx-5 shadow appearance-none border rounded w-full p-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
      id="username"
      type="text"
      placeholder="Type a message"
      v-model="message"
    /> -->
    <!-- <button
      class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
      type="button"
      @click.stop="send"
    >
      Send
    </button> -->

    <div class="absolute bottom-0 pad-40 left-0 w-full">
      <div
        class="p-3 bg-white grid grid-cols-7 gap-4"
        v-if="(file = 'image' && Preivew != null)"
      >
        <div class="relative" v-if="Preivew != null">
          <img :src="Preivew" class="object-cover h-24 w-full" alt="banh" />
          <div class="absolute top-0 right-0 m-2">
            <feather-icon
              icon="XIcon"
              @click="Preivew = null"
              class="text-white"
              svgClasses="w-4 h-4"
            />
          </div>
        </div>
      </div>
      <div
        class="p-3 bg-white grid grid-cols-8 gap-4"
        v-if="(file = 'video' && PreivewVideo != null)"
      >
        <div class="relative" v-if="PreivewVideo != null">
          <video controls class="setwidth">
            <source :src="PreivewVideo" />
          </video>
          <div class="absolute top-0 right-0 m-2">
            <feather-icon
              icon="XIcon"
              @click="PreivewVideo = null"
              class="text-white"
              svgClasses="w-4 h-4"
            />
          </div>
        </div>
      </div>
      <div
        class="p-3 bg-white grid grid-cols-8 gap-4"
        v-if="(file = 'pdf' && PreivewPdf != null)"
      >
        <div class="relative" v-if="PreivewPdf != null">
          <embed :src="PreivewPdf" type="" />
          <div class="absolute top-0 right-0 m-2">
            <feather-icon
              icon="XIcon"
              @click="PreivewPdf = null"
              class="text-white"
              svgClasses="w-4 h-4"
            />
          </div>
        </div>
      </div>
      <div
        class="p-3 bg-white grid grid-cols-8 gap-4"
        v-if="(file = 'audio' && Preivewaudio != null)"
      >
        <div class="relative" v-if="Preivewaudio != null">
          <video controls class="">
            <source :src="Preivewaudio" />
          </video>
          <div class="absolute top-0 right-0 m-2">
            <feather-icon
              icon="XIcon"
              @click="Preivewaudio = null"
              class="text-white"
              svgClasses="w-4 h-4"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="bg-fas z-50 p-2 flex items-center w-full">
      <div class="px-2">
        <!-- <div class="w-1/12 flex gap-3"> -->
        <!-- <feather-icon
          icon="SmileIcon"
          class="text-gray pl-2 cursor-pointer heiwidh"
        /> -->
        <div class="relative cursor-pointer">
          <feather-icon
            icon="LinkIcon"
            class="text-gray cursor-pointer cust-heiwidh"
          />
          <div class="absolute top-0 left-0">
            <input
              @change="uploadimage"
              type="file"
              multiple
              class="w-5 h-5 opacityd"
              :disabled="checkdisabled"
            />
          </div>
        </div>
      </div>
      <div class="w-full flex gap-2 items-center" v-if="sendfile == true">
        <!-- <div class="w-11/12 flex gap-2 items-center" v-if="sendfile == true"> -->
        <el-input
          placeholder="Please input"
          v-model="caption"
          :disabled="checkdisabled"
          @keyup.enter="sendFiles(caption)"
        ></el-input>
        <feather-icon
          icon="SendIcon"
          class="text-gray cursor-pointer mt-2"
          @click.stop="sendFiles(caption)"
        />
      </div>
      <div class="w-full flex gap-2 items-center" v-if="sendfile == false">
        <!-- <div class="w-11/12 flex gap-2 items-center" v-if="sendfile == false"> -->
        <el-input
          placeholder="Please input"
          v-model="message"
          :disabled="checkdisabled"
          @keyup.enter="send(message)"
        ></el-input>
        <feather-icon
          icon="SendIcon"
          class="text-gray cursor-pointer mt-2"
          @click.stop="send(message)"
        />
      </div>
    </div>

    <!-- v-if="isChatAssignedToSelf" -->
    <!-- <EmojiInputBox @sendMessage="send" /> -->
    <!-- <div class="cust-assign-btn flex justify-between" v-else>
      <p class="mx-4 font-medium cust-fonts-15 flex items-center">
        You are not assigned to this chat
      </p>
      <AssignChat text />
    </div> -->
  </div>
</template>

<script>
import EmojiInputBox from "../EmojiInputBox";
// import AssignChat from "../AssignChat";

import { mapGetters } from "vuex";
import { mapState } from "vuex";
export default {
  props: {
    checkdisabled: Boolean,
  },
  watch: {
    checkdisabled() {},
  },
  data() {
    return {
      message: "",
      caption: "",
      file: "",
      type: "message",
      Preivew: null,
      PreivewVideo: null,
      Preivewaudio: null,
      PreivewPdf: null,
      senddocs: false,
      getfiles: null,
      sendfile: false,
    };
  },
  components: {
    EmojiInputBox,
    // AssignChat,
  },
  computed: {
    ...mapGetters("whatsappChat", {
      activeChat: "activeChat",
    }),
    ...mapState("whatsappChat", {
      refreshPage: "refreshPage",
    }),
    ...mapState("admin", {
      login: "login",
    }),
    ...mapGetters("assignedChat", {
      isChatAssignedToSelf: "isChatAssignedToSelf",
    }),
  },
  methods: {
    async sendFiles(caption) {
      if (this.caption == "") return;
      console.log(this.getfiles);
      var phone = [];
      phone.push(this.activeChat.phone);

      try {
        const payload = new FormData();
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
        const file = this.getfiles.type;
        if (allowedTypes.includes(file)) {
          this.Preivew = URL.createObjectURL(this.getfiles);
          this.file = "image";
          payload.append("type", "image");
          payload.append("caption", this.caption);
        }
        const aallowtypevideos = ["video/mp4"];

        if (aallowtypevideos.includes(file)) {
          console.log("video true");
          this.file = "video";
          this.PreivewVideo = URL.createObjectURL(this.getfiles);
          payload.append("type", "video");
          payload.append("caption", this.caption);
        }
        const allowaudio = ["video/mpeg"];
        if (allowaudio.includes(file)) {
          console.log("audio true");
          this.file = "audio";
          this.Preivewaudio = URL.createObjectURL(this.getfiles);
          payload.append("type", "audio");
          payload.append("caption", this.caption);
        }

        payload.append("destination", phone);

        payload.append("username", this.login.name || "");
        payload.append("image", this.getfiles);

        await this.$store.dispatch("whatsappChat/sendtempletemsg", payload);
        this.$emit("messageSent");
        this.caption = "";
        this.sendfile = false;
        this.getfiles = null;
        (this.Preivew = null),
          (this.PreivewVideo = null),
          (this.Preivewaudio = null),
          (this.PreivewPdf = null),
          (this.file = "");
      } catch (err) {
        console.log(err);
        this.file = "";
        this.caption = "";
        this.sendfile = false;
        this.getfiles = null;
        (this.Preivew = null),
          (this.PreivewVideo = null),
          (this.Preivewaudio = null),
          (this.PreivewPdf = null);
      }
    },
    async uploadimage(e) {
      this.sendfile = true;
      var phone = [];
      console.log(e.target.files[0].type);
      this.getfiles = e.target.files[0];
      phone.push(this.activeChat.phone);

      console.log(phone, "phonephone");
      const payload = new FormData();
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      const file = e.target.files[0].type;
      if (allowedTypes.includes(file)) {
        if (e.target.files[0].size > 5 * 1024 * 1024) {
          this.sendfile = false;
          return alert("Max size allow only 10 mb");
        }
        this.Preivew = URL.createObjectURL(e.target.files[0]);
        this.file = "image";
        payload.append("type", "image");
        payload.append("caption", "media");
      }
      const aallowtypevideos = ["video/mp4"];

      if (aallowtypevideos.includes(file)) {
        console.log("video true");
        if (e.target.files[0].size > 10 * 1024 * 1024) {
          this.sendfile = false;
          return alert("Max size allow only 10 mb");
        }
        this.file = "video";
        this.PreivewVideo = URL.createObjectURL(e.target.files[0]);
        payload.append("type", "video");
        payload.append("caption", "media video ");
      }
      const allowaudio = ["video/mpeg"];
      if (allowaudio.includes(file)) {
        console.log("audio true");
        this.file = "audio";
        this.Preivewaudio = URL.createObjectURL(e.target.files[0]);
        payload.append("type", "video");
        payload.append("caption", "audio");
      }
      // const allowpdf = ["application/pdf"];
      // if (allowpdf.includes(file)) {
      //   console.log("pdf true");
      //   this.file = "pdf";
      //   this.PreivewPdf = URL.createObjectURL(e.target.files[0]);
      //   payload.append("type", "file");
      //    payload.append("caption", "file");
      // }

      // if (this.senddocs == false) return;
      payload.append("destination", phone);
      // payload.append("caption", "media testing");
      // payload.append("type", "image");
      return;
      this.$vs.loading();
      payload.append("username", this.login.name || "");
      payload.append("image", e.target.files[0]);
      return;
      await this.$store.dispatch("whatsappChat/sendtempletemsg", payload);
      this.caption = "";
      this.file = "";
    },
    async send(message) {
      if (!message) return;
      const payload = {
        destination: this.activeChat.phone,
        message: {
          isHSM: true,
          type: "text",
          text: message,
        },
        username: this.login.name || "",
      };

      try {
        // this.$vs.loading();

        let data = await this.$store.dispatch(
          "whatsappChat/sendMessage",
          payload
        );
        this.message = "";

        if (data.status == 200) {
          // await this.$store.dispatch("whatsappChat/fetchContacts");
          this.message = "";

          this.$vs.loading.close();
        }
        const payload2 = {
          isreply: true,
          number: this.activeChat.phone,
        };
        await this.$store.dispatch("AgentRouting/UpdateChatExp", payload2);
        let payload3 = {
          refreshPage: true,
        };

        await this.$store.commit("whatsappChat/REFRESH_PAGE", payload3);
        console.log(this.refreshPage, "datadatadata");

        this.$emit("messageSent");

        return;
      } catch (error) {
        if (error.response.data.reason === "User Not Opted In") {
          this.$swal(error.response.data.reason);
        }

        this.$vs.loading.close();
        return;
      }
    },
  },
  mounted() {
    this.file = "";
  },
};
</script>
<style>
.setwidth {
  width: 137px;
  height: 77px;
}
.heiwidh {
  height: 20px !important;
  width: 20px !important;
  color: #bababa !important;
}
.cust-heiwidh svg {
  height: 20px !important;
  width: 20px !important;
  color: #bababa !important;
}
</style>
